<template>
    <VBtn v-bind="$attrs" class="sr-button" :class="classList" v-on="$listeners">
        <slot />
    </VBtn>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

export default {
    name: 'SrButton',
    props: {
        type: {
            type: String,
            default: '',
        },
    },
    computed: {
        classList() {
            const classList = [USER_INPUT_CLASS];
            if (this.type) {
                classList.push(this.type);
            }
            return classList;
        },
    },
};
</script>
